import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface SnackbarMessage {
  message: string;
  variant: "primary" | "error";
  link?: {
    text: string;
    path: string;
  };
}

export type SnackbarState = SnackbarMessage[];

const initialState: SnackbarState = [];

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    addSnackbarQueueItem: (state, action: PayloadAction<SnackbarMessage>) => {
      state.push(action.payload);
    },
    snackbarQueueItemProcessed: (state) => {
      state.shift();
    },
  },
});

export const { addSnackbarQueueItem, snackbarQueueItemProcessed } =
  snackbarSlice.actions;

export default snackbarSlice.reducer;
